import { Grid } from '@mui/material';
import { useNavigate } from 'react-router';
import { EmptyCoursesList } from './empty-courses-list';
import {
  ResourceCard,
  ResourceCardContainer,
  ResourceCardContent,
  ResourceCardHeader,
  ResourceCardSkeleton,
  ResourceCardSubtitle,
  ResourceCardTitle,
} from '@/components/shared/resource-card';
import type { Trail } from '@/data/corporate-university/interfaces';
import { getAsset } from '@/utils/get-asset';

const GridSize = { xs: 12, sm: 6, md: 4, lg: 3 };

interface CoursesListProps {
  courses: Trail[];
  isLoading: boolean;
  isCompleted?: boolean;
  goToTrails: () => void;
  isTrails?: boolean;
}

export const CoursesList = ({
  courses,
  isLoading,
  isCompleted = false,
  isTrails = false,
  goToTrails,
}: CoursesListProps) => {
  const navigate = useNavigate();

  if (!isLoading && courses.length === 0) {
    return <EmptyCoursesList isCompleted={isCompleted} onAction={goToTrails} />;
  }

  return (
    <Grid container spacing={2}>
      {isLoading
        ? Array.from({ length: 4 }).map((_, index) => (
            <Grid size={GridSize} key={`skeleton-${index}`}>
              <ResourceCardSkeleton width="100%" />
            </Grid>
          ))
        : courses.map((course) => {
            const image = getAsset(course?.image);
            const count = course?._count?.courses ?? 0;
            const link = isTrails
              ? `/corporate-university/trilhas/${course.id}`
              : `/corporate-university/cursos/${course.id}`;

            return (
              <Grid size={GridSize} key={course.id}>
                <ResourceCard onClick={() => navigate(link)} href={link}>
                  <ResourceCardHeader
                    image={{ src: image, alt: course?.name, type: 'image' }}
                  />
                  <ResourceCardContainer>
                    <ResourceCardTitle>{course?.name}</ResourceCardTitle>
                    <ResourceCardContent>
                      {isTrails && (
                        <ResourceCardSubtitle>
                          {`${count} ${count === 1 ? 'curso' : 'cursos'}`}
                        </ResourceCardSubtitle>
                      )}
                    </ResourceCardContent>
                  </ResourceCardContainer>
                </ResourceCard>
              </Grid>
            );
          })}
    </Grid>
  );
};
